//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- EXPORTAÇÃO DO SERVIÇO LOAD COMPANIES ---------------//
// Responsável por requisitar à API as empresas existentes ao usuário
export default async function loadGroupsService() {
    try {
        const response = await api.get("/grupos-produtos");
        return response;
    } catch (error) {
        toast.error("Erro ao carregar grupos");
        return null;
    }
}